import Swal from 'sweetalert2'

export default defineNuxtPlugin((nuxtApp) => {
  const swalWithOptions = Swal.mixin({
    confirmButtonText: '확인',
    confirmButtonColor: '#0176F9',
    // cancelButtonColor: '#ff7674',
    customClass: {
      container: 'alert-container',
      icon: 'hide-swal-icon',
    },
    showClass: {
      popup: '' // 기본 적용된 바운스 애니메이션 제거하기 위한 옵션
    },
    hideClass: {
      popup: ''
    },
    scrollbarPadding: false,
    heightAuto: false,
    allowOutsideClick: false,
  })

  nuxtApp.provide('swal', swalWithOptions)
})
